import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=76d98db4&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=76d98db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d98db4",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QCheckbox,QInput,QSelect,QItem,QItemSection,QToggle,QCardSection,QRadio} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QCheckbox,QInput,QSelect,QItem,QItemSection,QToggle,QCardSection,QRadio})
